import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/confirm-dialog'

export type PendingSupplierDelete = {
  id: string
  label: string
}

type SupplierDeleteConfirmDialogProps = {
  pendingDelete: PendingSupplierDelete | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading?: boolean
}

export function SupplierDeleteConfirmDialog({
  pendingDelete,
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: SupplierDeleteConfirmDialogProps) {
  const { t } = useTranslation(['installations', 'common'])

  if (!pendingDelete) {
    return null
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('installations:suppliers.deleteConfirm.title')}
      desc={t('installations:suppliers.deleteConfirm.description', {
        label: pendingDelete.label,
      })}
      cancelBtnText={t('common:actions.cancel')}
      confirmText={t('common:actions.delete')}
      destructive
      isLoading={isLoading}
      handleConfirm={onConfirm}
    />
  )
}
